import { render } from "./selectDineInTable.vue?vue&type=template&id=15c2c239"
import script from "./selectDineInTable.vue?vue&type=script&lang=js"
export * from "./selectDineInTable.vue?vue&type=script&lang=js"

import "./selectDineInTable.vue?vue&type=style&index=0&id=15c2c239&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__